import React from 'react';

import { Group, Text, rem } from '@mantine/core';
import { Dropzone, FileRejection, FileWithPath, MIME_TYPES } from '@mantine/dropzone';
import { IconUpload, IconX, IconPhoto } from '@tabler/icons-react';
import notificationHandler from 'utils/notifications';

const DropFiles = ({
  handleFileChange,
}: {
  handleFileChange: (arg: FileWithPath[]) => void;
}): JSX.Element => {
  const { errorNotification } = notificationHandler();

  const handleReject = (files: FileRejection[]): void => {
    if (files[0].errors[0].code == 'file-too-large') {
      errorNotification('The selected file is too large. Please select a file smaller than 5MB.');
    } else {
      errorNotification(files[0].errors[0].message);
    }
  };

  return (
    <Dropzone
      onDrop={handleFileChange}
      onReject={handleReject}
      maxSize={5 * 1024 ** 2}
      accept={[MIME_TYPES.jpeg, MIME_TYPES.png, MIME_TYPES.pdf]}
      multiple={false}
    >
      <Group position='center' variant='xl' mih={220} style={{ pointerEvents: 'none' }}>
        <Dropzone.Accept>
          <IconUpload
            style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-blue-6)' }}
            stroke={1.5}
          />
        </Dropzone.Accept>
        <Dropzone.Reject>
          <IconX
            style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-red-6)' }}
            stroke={1.5}
          />
        </Dropzone.Reject>
        <Dropzone.Idle>
          <IconPhoto
            style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-dimmed)' }}
            stroke={1.5}
          />
        </Dropzone.Idle>

        <Text size='xl' inline>
          Drag your file here or click to select a file
        </Text>
      </Group>
    </Dropzone>
  );
};

export default DropFiles;
